<template>

<div class="alert" :data-theme="theme" :class="{'is-danger': danger, 'is-warning': warning, 'has-icon': icon, 'is-success': success, 'is-inline': isInline}">

	<app-icon :icon="icon" v-if="icon" class="alert-icon" />

	<div class="alert-text">

		<div v-if="title" class="alert-text-title">{{ title }}</div>
		<div v-if="text" class="alert-text-text">{{ text }}</div>
	
		<slot></slot>
		
	</div>

	<app-button :text="button" theme="redinvert" class="alert-button" v-if="button" v-on:click="$emit('click')" />

</div>

</template>

<script>

export default {

	props: ['danger', 'inline', 'icon', 'success', 'button', 'warning', 'theme', 'isInline' ,'title', 'text']

}

</script>

<style scoped>

.alert {
	background-color: #4082d3;
	font-size: 16px;
	line-height: 20px;
	text-align: center;
	display: flex;
	align-items: center;
	color: #fff;
	font-weight: 400;
	padding: 20px;
}

.alert-text-title {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 4px;
}

.alert.has-icon {
	display: flex;
}

.alert-icon {
	font-size: 40px;
}

.alert.has-icon .alert-text {
	text-align: left;
	padding-left: 20px;
}

.alert.is-inline {
	border-radius: 4px;
	margin-bottom: 20px;
}

.alert[data-theme="yellow"],
.alert.is-warning {
	background-color: #ffbe7a;
	color: #734444;
}

.alert[data-theme="blue"] {
	background-color: #4082d3;
}

.alert[data-theme="red"],
.alert.is-danger {
	background-color: #c55b5b;
}


.alert[data-theme="green"],
.alert.is-success {
	background-color: #4faa80;
}

.alert-button {
	flex-shrink: 0;
	margin-left: 20px;
}

</style>
